import { useTranslation } from 'react-i18next';
import googleStore from '../../Assets/Images/google-play.png';
import appleStore from '../../Assets/Images/app-store.png';
import homeMobileSM from '../../Assets/Images/Home/home_mobile-sm.svg';
import homeMobileLG from '../../Assets/Images/Home/home_mobile-lg.svg';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default function DownloadApp() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const { language } = useSelector((state) => state.lang);
  const { t } = useTranslation();
  const width = windowSize.width;
  const isMobile = width <= 767;

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="downloadApp" className="home__download-app">
      <img
        src={isMobile ? homeMobileSM : homeMobileLG}
        alt="Download the app"
        loading="lazy"
      />
      <div className="home__download-app--content">
        <h3 dangerouslySetInnerHTML={{ __html: t('home.downloadApp.title') }} />
        <p
          dangerouslySetInnerHTML={{
            __html: t('home.downloadApp.description'),
          }}
        />
        <div dir={language === 'ar' ? 'rtl' : 'ltr'}>
          <a
            href="https://apps.apple.com/eg/app/big-scrappers/id6557068840"
            target="_blank"
            rel="noopener noreferrer"
            style={{ order: language === 'ar' ? 2 : 1 }}
          >
            <img
              src={appleStore}
              alt="Apple store"
              className="d-block img-fluid"
              loading="lazy"
            />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.nationtech.bigscrappers"
            target="_blank"
            rel="noopener noreferrer"
            style={{ order: language === 'ar' ? 1 : 2 }}
          >
            <img
              src={googleStore}
              alt="Google store"
              className="d-block img-fluid"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
